import {SxProps, Theme} from '@mui/material'
import React from 'react'

import {useOptimizationSpecialistTimeRange} from '../hooks'

import {ShiftCommentsContainer} from './ShiftCommentsContainer'

type Props = {
  plantId: string
  cardBoxSx?: SxProps<Theme>
  placeholderWrapperSx?: SxProps<Theme>
}

export const CommentsContainer: React.FC<Props> = ({plantId, cardBoxSx, placeholderWrapperSx}) => {
  const {start, end} = useOptimizationSpecialistTimeRange(plantId)

  return (
    <ShiftCommentsContainer
      plantId={plantId}
      cardBoxSx={cardBoxSx}
      placeholderWrapperSx={placeholderWrapperSx}
      from={start}
      to={end}
    />
  )
}
